<script setup lang="ts">

// ===== Принимаем то, что нам важно управлять =====
const props = defineProps<{
  modelValue: string
  label?: string
  mask?: string
}>()

const emit = defineEmits(["update:modelValue"])

const inputRef = ref<{ isFocused: boolean } | null>(null)

const innerValue = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val)
})

const smartProps = computed(() => {
  const res = {
    placeholder: "",
    isLabelInside: false,
    mask: "",
    title: ""
  }

  if (!inputRef.value?.isFocused && !innerValue.value) {
    res.placeholder = props.label || ""
    res.isLabelInside = false
  } else {
    res.isLabelInside = true
    res.title = props.label ?? ""
    res.mask = props.mask ?? ""
  }


  return res
})
</script>

<template>
  <ui-custom-input
      ref="inputRef"
      v-model="innerValue"
      v-bind="$attrs"
      :title="smartProps.title"
      :placeholder="smartProps.placeholder"
      :is-label-inside="smartProps.isLabelInside"
      :mask="smartProps.mask"
  >
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps"/>
    </template>
  </ui-custom-input>
</template>